import React from 'react'

import { useMediaQueries } from 'hooks'

import { Typo } from 'components/_old/Typo'

import { Typography } from 'components/atoms/Typography'

type TitleProps = {
  className: string
}

const Title = ({ className }: TitleProps): JSX.Element => {
  const { desktop } = useMediaQueries()

  return (
    <Typography tag="h1" size={desktop ? 32 : 24} weight="semibold" lineHeight="small" className={className}>
      <Typo>Your transfers</Typo>
    </Typography>
  )
}

export { Title }
